import type { JSX } from 'react'
import type { ITextBlockProps } from '../../TextBlock'

import { TextBlockDirection, TextBlockRowGap } from '../../TextBlock.h'
import { TextBlockSubscriptionStatusSC } from './TextBlockSubscriptionStatus.styled'

export interface ITextBlockSubscriptionStatusProps extends ITextBlockProps {}

export const TextBlockSubscriptionStatus = ({
  children,
  direction = TextBlockDirection.COLUMN,
  rowGap = TextBlockRowGap.INDENT_40,
  alignItems,
  justifyContent,
  flexBasis,
  flexGrow,
  width,
  flexBasisAuto,
}: ITextBlockSubscriptionStatusProps): JSX.Element => (
  <TextBlockSubscriptionStatusSC
    flexBasisAuto={flexBasisAuto}
    direction={direction}
    rowGap={rowGap}
    alignItems={alignItems}
    justifyContent={justifyContent}
    flexBasis={flexBasis}
    flexGrow={flexGrow}
    width={width}
  >
    {children}
  </TextBlockSubscriptionStatusSC>
)
